<template>
    <div class="page">
        <div>
            <el-form
                class="query-form"
                :model="queryForm"
                ref="queryForm"
                :rules="queryFormRules"
                label-width="80px"
                :inline="true"
                size="normal"
                @submit.native.prevent
            >
                <el-form-item label="">
                    <el-input size="small" v-model="queryForm.userName" placeholder="账号"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-input size="small" v-model="queryForm.userMobile" placeholder="手机"></el-input>
                </el-form-item>
                <!-- <el-form-item label="">
                    <el-input size="small" v-model="queryForm.userRealnclassame" placeholder="姓名"></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="Reset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="parentList">
            <div v-if="Object.keys(this.parentList).length !== 0" class="custom-tree-node">
                <span>父级>></span>
                <span>账号:{{ parentList.userName }}({{ parentList.mppGrade.gradeName }}-{{ parentList.isEffective }}-{{ parentList.marketSeq }})  </span>
				<span>手机:{{ parentList.userMobile }} </span>
				<span>昵称:{{ parentList.userNickname }} </span>
				<span>姓名:{{ parentList.userRealname }} </span>
                <!--span>个人业绩:{{ parentList.personalPerformance || 0 }}</span>
                <span>团队业绩:{{ parentList.teamPerformance || 0 }}</span-->
                <span>直推/有效:{{ parentList.directNumber || 0 }}/{{ parentList.directEfficientNumber || 0 }}</span>
                <span>团队/有效:{{ parentList.teamNumber || 0 }}/{{ parentList.teamEfficientNumber || 0 }}</span>
                <!--span>等级:{{ parentList.gradeName }}</span-->

                <!--div class="operation">
                    <div @click="checkUser(parentList.id)">
                        <Icon size="16">
                            <Eye24Regular />
                        </Icon>
                        <span class="operation-label">查看</span>
                    </div>
                </div-->
            </div>
            <div v-else class="ziti">暂无父级</div>
        </div>
        <el-tree :props="props" :data="dataList" :load="loadNode" :expand-on-click-node="false" lazy @check-change="handleCheckChange">
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>账号:{{ data.userName }}({{ data.gradeName }}-{{ data.isEffective }}-{{ data.marketSeq }}) </span>
				<span>手机:{{ data.userMobile }} </span>
				<span>昵称:{{ data.userNickname }} </span>
				<span>姓名:{{ data.userRealname }} </span>
                <!--span>个人业绩:{{ data.personalPerformance || 0 }}</span>
                <span>团队业绩:{{ data.teamPerformance || 0 }}</span-->
                <span>直推/有效:{{ data.directNumber || 0 }}/{{ data.directEfficientNumber || 0 }}</span>
                <span>团队/有效:{{ data.teamNumber || 0 }}/{{ data.teamEfficientNumber || 0 }}</span>
                <span>团队业绩/小区业绩:{{ data.teamPerformance1 || 0 }}/{{ data.smallPerformance1 || 0 }}</span>
				
                <!--span>等级:等级:{{ parentList.gradeName }}</span-->

                <!--div class="operation">
                    <div @click="checkUser(node.data.id)">
                        <Icon size="16">
                            <Eye24Regular />
                        </Icon>
                        <span class="operation-label">查看</span>
                    </div>
                </div-->
            </span>
        </el-tree>

        <!-- 新增/查看/修改用户信息 -->
        <el-dialog :title="userStates[userState]" :visible.sync="showDialog" width="60%" @close="closeDialog">
            <div>
                <el-form :model="user" ref="userForm" label-width="80px" :inline="true" size="small">
                    <el-divider content-position="left">
                        <i class="el-icon-lock text-lg"></i>
                        <span class="ml-1 text-base text-black font-semibold">登录信息</span>
                    </el-divider>
                    <el-form-item label="账号" prop="userName">
                        <el-input v-model="user.userName" size="small" :disabled="userState == 'check'" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="密码"
                        prop="newPassword"
                        :rules="user.id ? [] : [{ required: true, message: '密码不能为空', trigger: 'blur' }]"
                    >
                        <el-input
                            type="password"
                            :placeholder="userState == 'add' ? '' : '若不修改，请留空'"
                            v-model="user.newPassword"
                            size="small"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPass">
                        <el-input
                            type="password"
                            :placeholder="userState == 'add' ? '' : '若不修改，请留空'"
                            v-model="user.confirmPass"
                            size="small"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="允许登录">
                        <el-select size="small" v-model="user.status" :disabled="userState == 'check'" style="width: 200px">
                            <el-option label="正常" :value="1"> </el-option>
                            <el-option label="禁用" :value="0"> </el-option>
                        </el-select>
                    </el-form-item>

                    <el-divider content-position="left">
                        <i class="el-icon-user text-lg"></i>
                        <span class="ml-1 text-base text-black font-semibold">身份信息</span>
                    </el-divider>
                    <el-form-item label="昵称" prop="userNickname">
                        <el-input v-model="user.userNickname" size="small" :disabled="userState == 'check'" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="手机">
                        <el-input v-model="user.userMobile" size="small" :disabled="userState == 'check'" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="电话">
                        <el-input
                            v-model="user.userTelephone"
                            size="small"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱">
                        <el-input v-model="user.userEmail" size="small" :disabled="userState == 'check'" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="头像">
                        <el-upload action="" :disabled="userState == 'check'" class="avatar-uploader" :show-file-list="false">
                            <img v-if="user.userHeader" :src="user.userHeader" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>

                    <el-divider content-position="left">
                        <i class="el-icon-postcard text-lg"></i>
                        <span class="ml-1 text-base text-black font-semibold">岗位信息</span>
                    </el-divider>
                    <el-form-item label="公司" prop="companyId">
                        <el-select
                            size="small"
                            v-model="user.companyId"
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                            <el-tree default-expand-all :data="departmentList" :props="treeProps">
                                <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                                    <el-option :label="node.label" :value="data.id"> </el-option>
                                </div>
                            </el-tree>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="部门" prop="deptId">
                        <el-select
                            size="small"
                            v-model="user.deptId"
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                            <el-tree default-expand-all :data="departmentList" :props="treeProps">
                                <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                                    <el-option :label="node.label" :value="data.id"> </el-option>
                                </div>
                            </el-tree>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="工号" prop="workNumber">
                        <el-input style="width: 200px" v-model="user.workNumber" size="small" :disabled="userState == 'check'"></el-input>
                    </el-form-item>
                    <el-form-item label="岗位">
                        <el-select
                            size="small"
                            v-model="user.postIdList"
                            multiple
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                            <el-option v-for="post in postList" :key="post.id" :label="post.postName" :value="post.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色">
                        <el-select
                            size="small"
                            v-model="user.roleIds"
                            multiple
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                            <el-option v-for="role in roleList" :key="role.id" :label="role.roleName" :value="role.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input
                            style="width: 200px"
                            type="textarea"
                            :rows="2"
                            v-model="user.remarks"
                            size="small"
                            :disabled="userState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-divider content-position="left">
                        <i class="el-icon-postcard text-lg"></i>
                        <span class="ml-1 text-base text-black font-semibold">升级信息</span>
                    </el-divider>
                    <el-form-item label="是否授权" prop="isHand">
                        <el-select size="small" v-model="user.isHand" :disabled="userState == 'check'" style="width: 200px">
                            <el-option label="未授权" :value="0"> </el-option>
                            <el-option label="授权" :value="1"> </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="授权等级" prop="handGrade">
                        <el-input style="width: 200px" v-model="user.handGrade" size="small" :disabled="userState == 'check'"></el-input>
                    </el-form-item>
                    <el-form-item label="等级" prop="mppGrade.gradeName">
                        <el-input
                            style="width: 200px"
                            v-if="user.mppGrade == null"
                            size="small"
                            :disabled="userState == 'check'"
                        ></el-input>

                        <el-input
                            v-else
                            style="width: 200px"
                            v-model="user.mppGrade.gradeName"
                            size="small"
                            :disabled="userState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="直推人数" prop="workNumber">
                        <el-input style="width: 200px" v-model="user.directNumber" size="small" :disabled="userState == 'check'"></el-input>
                    </el-form-item>
                    <el-form-item label="团队人数" prop="workNumber">
                        <el-input style="width: 200px" v-model="user.teamNumber" size="small" :disabled="userState == 'check'"></el-input>
                    </el-form-item>
                    <el-form-item label="个人业绩" prop="workNumber">
                        <el-input
                            style="width: 200px"
                            v-model="user.personalPerformance"
                            size="small"
                            :disabled="userState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="团队业绩" prop="workNumber">
                        <el-input
                            style="width: 200px"
                            v-model="user.teamPerformance"
                            size="small"
                            :disabled="userState == 'check'"
                        ></el-input>
                    </el-form-item> -->
                </el-form>
            </div>

            <div slot="footer" class="flex justify-end">
                <el-button @click="closeDialog">关闭</el-button>
                <el-button type="primary" @click="submitForm()" v-if="userState != 'check'">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { Edit24Regular, Delete24Regular, Settings24Regular, Eye24Regular } from '@v2icons/fluent';
import UserListTable from '@/components/organization/UserListTable.vue';
import { getDepartmentList } from '@/api/dept.js';
import { getPostList } from '@/api/post.js';
import { getRoleList } from '@/api/role.js';
import { getUserList, getUserById, addUser, deleteUser, editUser, uploadAvatar } from '@/api/user.js';

export default {
    components: {
        UserListTable,
        Eye24Regular,
        Edit24Regular,
        Settings24Regular
    },
    data() {
        return {
            props: {
                label: 'name',
                children: 'zones'
            },
            treeProps: {
                children: 'children',
                label: 'deptName'
            },
            parentList: {},
            showDialog: false,
            dataList: [],
            count: 1,
            chiList: [],
            departmentList: [],
            postList: [],
            roleList: [],
            userStates: {
                add: '添加用户',
                check: '查看用户',
                edit: '编辑用户'
            },
            userState: 'check',
            user: {
                id: '',
                userName: '', //用户名
                newPassword: null, //密码
                confirmPass: null,
                userRealname: '', //真实姓名
                userMobile: '', //手机号码
                userTelephone: '', //用户电话
                userEmail: '', //邮箱
                companyId: '', //公司
                deptId: '', //部门
                workNumber: '', //工号
                postIds: '', //岗位
                mppGrade: {
                    gradeName: ''
                },
                mppDept: {},
                userHeader: '',
                company: {},
                roleIds: [],
                postIdList: [],
                roleId: '',
                status: 1,
                personalPerformance: '', //个人业绩
                teamPerformance: '', //团队业绩
                directNumber: '', //直推人数
                directEfficientNumber: '', //直推人数
                teamNumber: '', //团队人数
                teamEfficientNumber: ''
            },
            currentUserId: '',
            queryForm: {
                deptId: '',
                userName: '',
                userRealname: '',
                userMobile: ''
            },
            queryFormRules: {},
            yesNoEnumList: []
        };
    },
    created() {
        this.findSubAndParentList();
        this.getDepartmentList();
        this.getPostList();
        this.getRoleList();
        this.getYesNo();
    },
    filters: {
        empty: (value) => {
            if (value == null) {
                return 0;
            } else {
                return value;
            }
        }
    },
    methods: {
        // 获取数据
        findSubAndParentList(id, resolve) {
            console.log(id);
            get(`/mpp/user/findSubAndParentList`, { parentId: id }).then((res) => {
                console.log(res);
                if (res.success && res.code == 200) {
                    if (id == undefined) {
                        res.list.forEach((item) => {
							if(item.growth){
								this.dataList.push({
								    id: item.id,
								    userName: item.userName,
								    userNickname: item.userNickname,
								    userRealname: item.userRealname,
								    userMobile: item.userMobile,
								    personalPerformance: item.personalPerformance,
								    teamPerformance: item.teamPerformance,
								    teamPerformance1: item.growth.teamPerformance,
                                    smallPerformance1: item.growth.smallPerformance,
								    directNumber: item.growth.directNumber,
								    directEfficientNumber: item.growth.directEffectiveNumber,
								    teamNumber: item.growth.teamNumber,
								    teamEfficientNumber: item.growth.teamEffectiveNumber,
								    gradeName: item.mppGrade.gradeName,
									isEffective:item.isEffective,
									marketSeq:item.marketSeq
								});
							}else{
								this.dataList.push({
								    id: item.id,
								    userName: item.userName,
								    userNickname: item.userNickname,
								    userRealname: item.userRealname,
								    userMobile: item.userMobile,
								    personalPerformance: item.personalPerformance,
								    teamPerformance: item.teamPerformance,
								    teamPerformance1: 0,
                                    smallPerformance1: 0,
								    directNumber: 0,
								    directEfficientNumber: 0,
								    teamNumber: 0,
								    teamEfficientNumber: 0,
								    gradeName: item.mppGrade.gradeName,
									isEffective:item.isEffective,
									marketSeq:item.marketSeq
								});
							}
                            
                        });
                        this.chiList = res.list;
                        this.parentList = {};

                        return;
                    }

                    this.chiList = res.list;

                    let newArr = [];
                    res.list.forEach((item) => {
						if(item.growth){
							newArr.push({
								id: item.id,
								userName: item.userName,
								userNickname: item.userNickname,
								userRealname: item.userRealname,
								userMobile: item.userMobile,
								personalPerformance: item.personalPerformance,
								teamPerformance: item.teamPerformance,
                                teamPerformance1: item.growth.teamPerformance,
                                smallPerformance1: item.growth.smallPerformance,
								directNumber: item.growth.directNumber,
								directEfficientNumber: item.growth.directEffectiveNumber,
								teamNumber: item.growth.teamNumber,
								teamEfficientNumber: item.growth.teamEffectiveNumber,
								gradeName: item.mppGrade.gradeName,
								isEffective:item.isEffective,
								marketSeq:item.marketSeq
							});
						}else{
							newArr.push({
								id: item.id,
								userName: item.userName,
								userNickname: item.userNickname,
								userRealname: item.userRealname,
								userMobile: item.userMobile,
								personalPerformance: item.personalPerformance,
								teamPerformance: item.teamPerformance,
                                teamPerformance1: 0,
                                smallPerformance1: 0,
								directNumber: 0,
								directEfficientNumber: 0,
								teamNumber: 0,
								teamEfficientNumber: 0,
								gradeName: item.mppGrade.gradeName,
								isEffective:item.isEffective,
								marketSeq:item.marketSeq
							});
						}
                    });
                    if (res.parentList.length !== 0) {
                        this.parentList = res.parentList[0];
						
						this.parentList.gradeName = res.parentList[0].mppGrade.gradeName;
						
						this.parentList.teamNumber = res.parentList[0].growth.teamNumber;
						this.parentList.teamEfficientNumber = res.parentList[0].growth.teamEffectiveNumber;
						this.parentList.directNumber = res.parentList[0].growth.directNumber;
						this.parentList.directEfficientNumber = res.parentList[0].growth.directEffectiveNumber;
                    } else {
                        this.parentList = {};
                    }

                    resolve(newArr);
                }
            });
        },
        //获取是否枚举
        getYesNo(){
            get('/mpp/utils/getEnum',{ enumType:'yes_no' }).then((res)=>{
                if(res.success){
                    this.yesNoEnumList = res.enumList;
                }
            })
        },
        handleCheckChange(data, checked, indeterminate) {
            console.log(data, checked, indeterminate);
        },
        handleNodeClick(data) {
            console.log(data);
        },
        loadNode(node, resolve) {
            console.log(node);
            if (node.level === 0) {
                // this.getdataList();
                return resolve(this.dataList);
            }
            // if (node.level > 3) return resolve([]);

            var hasChild = true;
            // if (this.chiList.length != 0) {
            //     hasChild = true;
            // }
            // if (node.data.name === 'region1') {
            //     hasChild = true;
            // } else if (node.data.name === 'region2') {
            //     hasChild = false;
            // } else {
            //     hasChild = Math.random() > 0.5;
            // }

            setTimeout(() => {
                var data;
                if (hasChild) {
                    this.findSubAndParentList(node.data.id, resolve);
                    data = [];
                } else {
                    data = [];
                }

                resolve(data);
            }, 500);
        },
        // 关闭弹窗
        closeDialog() {
            // this.$refs.contentEditor.init('');
            this.showDialog = false;
            this.user = {
                id: '',
                userName: '', //用户名
                newPassword: null, //密码
                confirmPass: null,
                userRealname: '', //真实姓名
                userMobile: '', //手机号码
                userTelephone: '', //用户电话
                userEmail: '', //邮箱
                companyId: '', //公司
                deptId: '', //部门
                workNumber: '', //工号
                postIds: '', //岗位
                mppGrade: {
                    gradeName: ''
                },
                mppDept: {},
                userHeader: '',
                company: {},
                roleIds: [],
                postIdList: [],
                roleId: '',
                status: 1,
                personalPerformance: '', //个人业绩
                teamPerformance: '', //团队业绩
                directNumber: '', //直推人数
                teamNumber: '' //团队人数
            };
        },
        checkUser(userId) {
            console.log(userId);
            this.currentUserId = userId;
            this.getUserById();
            this.showDialog = true;
            this.userState = 'check';
        },
        getUserById() {
            getUserById({ id: this.currentUserId }).then((res) => {
                if (res.success) {
                    this.user = { ...this.user, ...res.mppUser, postIdList: res.mppUser.postIds ? res.mppUser.postIds.split(',') : [] };
                    console.log(this.user);
                }
            });
        },
        checkShopProduct(shopProductId) {
            this.showDialog = true;
        },
        getDepartmentList() {
            getDepartmentList({ deptName: this.organizationKeyword }).then((res) => {
                if (res.success) {
                    this.departmentList = res.treeData;
                }
            });
        },
        getPostList() {
            getPostList({ pageNum: 1, pageSize: 10 }).then((res) => {
                if (res.success) {
                    this.postList = res.page.list;
                }
            });
        },
        getRoleList() {
            getRoleList({ pageNum: 1, pageSize: 10 }).then((res) => {
                if (res.success) {
                    this.roleList = res.page.list;
                }
            });
        },
        search() {
            get(`/mpp/user/findSubAndParentList`, { userName: this.queryForm.userName, userMobile: this.queryForm.userMobile }).then((res) => {
                this.dataList = [];
                if (res.success && res.code == 200) {
                    res.list.forEach((item) => {
						if(item.growth){
							this.dataList.push({
							    id: item.id,
							    userName: item.userName,
							    userNickname: item.userNickname,
							    userRealname: item.userRealname,
							    userMobile: item.userMobile,
							    personalPerformance: item.personalPerformance,
							    teamPerformance: item.teamPerformance,
							    teamEfficientNumber: item.growth.teamEffectiveNumber,
							    directNumber: item.growth.directNumber,
							    directEfficientNumber: item.growth.directEffectiveNumber,
							    teamNumber: item.growth.teamNumber,
							    gradeName: item.mppGrade.gradeName,
								isEffective:item.isEffective,
								marketSeq:item.marketSeq
							});
						}else{
							this.dataList.push({
							    id: item.id,
							    userName: item.userName,
							    userNickname: item.userNickname,
							    userRealname: item.userRealname,
							    userMobile: item.userMobile,
							    personalPerformance: item.personalPerformance,
							    teamPerformance: item.teamPerformance,
							    teamEfficientNumber: 0,
							    directNumber: 0,
							    directEfficientNumber: 0,
							    teamNumber: 0,
							    gradeName: item.mppGrade.gradeName,
								isEffective:item.isEffective,
								marketSeq:item.marketSeq
							});
						}
                        
                    });
                    if (res.parentList.length !== 0) {
                        this.parentList = res.parentList[0];
                        this.parentList.gradeName = res.parentList[0].mppGrade.gradeName;
						
						this.parentList.teamNumber = res.parentList[0].growth.teamNumber;
						this.parentList.teamEfficientNumber = res.parentList[0].growth.teamEffectiveNumber;
						this.parentList.directNumber = res.parentList[0].growth.directNumber;
						this.parentList.directEfficientNumber = res.parentList[0].growth.directEffectiveNumber;
			
                    } else {
                        this.parentList = {};
                    }
                }
            });
        },
        Reset() {
            this.queryForm = {};
            this.dataList = [];
            this.findSubAndParentList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.el-tree {
    max-width: 200%;
}
::v-deep .el-tree-node__content {
    height: 38px;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    padding-right: 8px;
    span {
        margin-right: 10px;
    }
}
.operation {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
    color: #409eff;
    span:first-child {
        margin-right: 0;
    }
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.parentList {
    background-color: #fff;
    margin-bottom: 10px;
    line-height: 30px;
    padding: 10px;

    div:last-child {
        text-align: center;
    }
    .ziti {
        font-size: 14px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
